import Search from './components/search';
import SelectRegion from './components/selectRegion';
import GetTickets from './components/getTickets';
import Header from './components/header';
import Shop from './components/shop';
import Ellipsis from './components/ellipsis';
import Faq from './components/faq';
import SoonEventsSection from './components/soonEventsSection';
import Select from './components/select';
import LazyLoadImage from './classes/lazyloadimage';
import Thumbnail from './components/thumbnail';
import SearchPage from './components/searchPage';
import Sitemap from './classes/sitemap';
import Group from './components/group';
import CopyToClipboard from './classes/copyToClipboard';
import GoogleTagManager from './classes/googleTagManager';
import Matomo from './classes/matomo';
import Carousel from './classes/carousel';
import HomeFilter from './components/homeFilter';
import NavbarSkeleton from "./skeletons/navbar";
import BroadcastEvent from "./components/broadcastEvent"
import CartIcon from "./components/cartIcon";

document.addEventListener('DOMContentLoaded', () => {
    new GoogleTagManager();
    new Matomo();
    new Select();
    new SearchPage();
    new Thumbnail();
    new Ellipsis();
    new LazyLoadImage();
    new Search();
    new Header();
    new SelectRegion();
    new GetTickets();
    if (document.getElementsByClassName('shop-integration')[0]) {
        new Shop();
    }
    new Faq();
    if(document.getElementsByClassName('home-page')[0]) {
        new SoonEventsSection();
    }
    new CartIcon();
    new Sitemap();
    new Group();
    new CopyToClipboard();
    new Carousel();
    new HomeFilter();
    new NavbarSkeleton();
    new BroadcastEvent();
});
